import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { AggregateLevel } from 'src/types';
import { useMMDataContext } from '../../../contexts/MMDataContext';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { BarChart3 } from 'lucide-react';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';

type RomiProps = {
  aggregateLevel: AggregateLevel;
};

export const Romi: React.FC<RomiProps> = ({ aggregateLevel }) => {
  const { romi } = useMMDataContext();

  const keyMetricData: KeyMetricData = useMemo(() => {
    return {
      isLoading: romi.isLoading,
      isError: romi.isError,
      name: 'ROMI',
      isEuro: false,
      summaryValue: romi.total,
      data: getAggregateLevelData(romi, aggregateLevel),
    };
  }, [aggregateLevel, romi]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      title="ROMI"
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={keyMetricData.isLoading}
      isError={keyMetricData.isError}
      icon={<ChakraIcon as={BarChart3} boxSize={5} color="gray.500" />}
    />
  );
};
